import Feed from 'features/feed/screens/Feed';
import OnBoardingScreen from 'login/screens/onboarding/OnBoardingScreen';
import React from 'react';
import { useIsSignedInWeb } from '../hooks/useIsSignedInWeb';
const HomeScreen = (props) => {
    const { isSignedIn } = useIsSignedInWeb();
    return isSignedIn ? <Feed {...props}/> : <OnBoardingScreen {...props}/>;
};
export default HomeScreen;
